// TEAM FEATURES
export const FREE_PLAN_DESCRIPTIONS = [
	{ text: 'Unlimited features', isSupported: true },
	{ text: 'i-async', isSupported: true },
	{ text: 'Per user connection', isSupported: true },
	{ text: '500 automation tasks', isSupported: true },
	{ text: '30-day task log', isSupported: true },
	{ text: '30-day utilization analytics', isSupported: true },
	{ text: 'Up to 3 members', isSupported: true },
];
export const PLUS_PLAN_DESCRIPTIONS = [
	{ text: 'Webhooks and APl calls', isSupported: true },
	{ text: 'Custom code', isSupported: true },
	{ text: 'My input log', isSupported: true },
	{ text: 'Version history', isSupported: true },
	{ text: '5,000 automation tasks', isSupported: true },
	{ text: 'Up to 30 members per type', isSupported: true },
	{ text: '10 lite users', isSupported: true },
];
export const BUSINESS_PLAN_DESCRIPTIONS = [
	{ text: 'Creator spaces permissions', isSupported: true },
	{ text: 'Groups', isSupported: true },
	{ text: 'Synced groups', isSupported: true },
	{ text: 'Issue management', isSupported: true },
	{ text: 'Reusable subflows', isSupported: true },
	{ text: 'Shared notification inboxes', isSupported: true },
	{ text: 'Up to 100 members per type', isSupported: true },
];
export const ENTERPRISE_PLAN_DESCRIPTIONS = [
	{ text: 'Unlimited utilization analytics', isSupported: true },
	{ text: 'Custom task log retention', isSupported: true },
	{ text: 'Sensitive connections', isSupported: true },
	{ text: 'SSO and user provisioning', isSupported: true },
	{ text: 'Advanced permissions', isSupported: true },
	{ text: 'Premium support', isSupported: true },
	{ text: 'Optional single-tenant VPC', isSupported: true },
];
// CUSTOMER FEATURES
export const FREE_CUSTOMER_PLAN_DESCRIPTIONS = [
	{ text: 'Unlimited features', isSupported: true },
	{ text: 'Most integrations', isSupported: true },
	{ text: 'Intelligent Async', isSupported: true },
	{ text: 'Customize theme', isSupported: true },
	{ text: '30-day utilization analytics', isSupported: true },
	{ text: '30-day task log', isSupported: true },
];
export const ENGAGE_PLAN_DESCRIPTIONS = [
	{ text: 'URL Parameters as input', isSupported: true },
	{ text: 'Transactional email', isSupported: true },
	{ text: 'Mini-apps', isSupported: true },
	{ text: 'Customer authentication', isSupported: true },
	{ text: 'Redirect on completion', isSupported: true },
	{ text: 'Outgoing Webhooks and API', isSupported: true },
];
export const SCALE_PLAN_DESCRIPTIONS = [
	{ text: 'Custom publishing domain', isSupported: true },
	{ text: 'Custom email domain', isSupported: true },
	{ text: 'Event tracking (soon)', isSupported: true },
	{ text: 'Salesforce integration', isSupported: true },
	{ text: 'Session duration control', isSupported: true },
	{ text: 'Minimize Ply branding', isSupported: true },
];
export const ENTERPRISE_CUSTOMER_PLAN_DESCRIPTIONS = [
	{ text: 'Unlimited utilization analytics', isSupported: true },
	{ text: 'Custom task log retention', isSupported: true },
	{ text: 'SSO for customers and team', isSupported: true },
	{ text: 'Speedy custom requests', isSupported: true },
	{ text: 'White-glove support', isSupported: true },
	{ text: 'Custom billing', isSupported: true },
];
